import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PaymentContext } from "../../context/PaymentContext";
import "./PaymentResult.css"
const PaymentResult = () => {
  const { paymentResult } = useContext(PaymentContext);
  const { status } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  // URL'den tüm parametreleri al
  const urlParams = new URLSearchParams(window.location.search);
  const allParams = Object.fromEntries(urlParams.entries());

  useEffect(() => {
    const handlePaymentResult = async () => {
      if (!allParams || Object.keys(allParams).length === 0) {
        return;
      }

      try {
        const result = await paymentResult(allParams);

        if (status === 'success' && result?.amount) {
          document.cookie = "share_ref=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

          fbq('track', 'Purchase', {
            value: parseFloat(result.amount),
            currency: 'TRY',
            content_ids: result.order_id || '',
            content_type: 'product'
          });
        }
      } catch (error) {
        console.error("Ödeme sonucu işlenirken hata:", error);
        setError("Ödeme sonucu işlenirken bir hata oluştu.");
      }
    };

    handlePaymentResult();
  }, [status, paymentResult]);

  const handleGoHome = () => {
    navigate('/');
  };

  // Hata durumu
  if (error) {
    return (
      <div className="payment-error-container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          borderRadius: '30px',
          padding: '50px 40px',
          textAlign: 'center',
          boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          maxWidth: '500px',
          width: '100%'
        }}>
          <div style={{
            width: '100px',
            height: '100px',
            margin: '0 auto 30px',
            background: 'linear-gradient(45deg, #ff6b6b, #ffa726)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '50px',
            color: 'white',
            animation: 'pulse 2s infinite'
          }}>
            ⚠️
          </div>
          <h2 style={{
            color: '#333',
            marginBottom: '20px',
            fontWeight: '700',
            fontSize: '28px'
          }}>Bir Hata Oluştu</h2>
          <p style={{
            color: '#666',
            marginBottom: '30px',
            fontSize: '16px',
            lineHeight: '1.6'
          }}>{error}</p>
          <button
            onClick={handleGoHome}
            style={{
              background: 'linear-gradient(45deg, #ff6b6b, #ffa726)',
              color: 'white',
              border: 'none',
              padding: '15px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 10px 25px rgba(255, 107, 107, 0.3)'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 15px 35px rgba(255, 107, 107, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 10px 25px rgba(255, 107, 107, 0.3)';
            }}
          >
            🏠 Ana Sayfaya Dön
          </button>
        </div>
        <style>
          {`
            @keyframes pulse {
              0% { transform: scale(1); }
              50% { transform: scale(1.1); }
              100% { transform: scale(1); }
            }
          `}
        </style>
      </div>
    );
  }

  // Başarılı ödeme
  if (status === 'success') {
    return (
      <div className="success-container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          borderRadius: '30px',
          padding: '50px 40px',
          textAlign: 'center',
          boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          maxWidth: '500px',
          width: '100%',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            width: '120px',
            height: '120px',
            margin: '0 auto 30px',
            background: 'linear-gradient(45deg, #4ecdc4, #44a08d)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '60px',
            color: 'white',
            animation: 'bounce 2s infinite',
            position: 'relative',
            zIndex: '2'
          }}>
            ✓
          </div>
          <h1 style={{
            color: '#333',
            marginBottom: '20px',
            fontWeight: '700',
            fontSize: '32px',
            background: 'linear-gradient(45deg, #4ecdc4, #44a08d)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            position: 'relative',
            zIndex: '2'
          }}>Ödeme Başarılı!</h1>
          <p style={{
            color: '#666',
            marginBottom: '30px',
            fontSize: '18px',
            lineHeight: '1.6',
            position: 'relative',
            zIndex: '2'
          }}>
            🎉 Ödemeniz başarıyla tamamlandı.<br />
            Teşekkür ederiz!
          </p>
          <button
            onClick={handleGoHome}
            style={{
              background: 'linear-gradient(45deg, #4ecdc4, #44a08d)',
              color: 'white',
              border: 'none',
              padding: '15px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 10px 25px rgba(78, 205, 196, 0.3)',
              position: 'relative',
              zIndex: '2'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 15px 35px rgba(78, 205, 196, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 10px 25px rgba(78, 205, 196, 0.3)';
            }}
          >
            🏠 Ana Sayfaya Dön
          </button>
        </div>
        <style>
          {`
            @keyframes bounce {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-10px); }
            }
            @keyframes confetti {
              0% { transform: translateY(0) rotate(0deg); }
              100% { transform: translateY(-10px) rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  // Başarısız ödeme
  if (status === 'failure') {
    return (
      <div className="failure-container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          borderRadius: '30px',
          padding: '50px 40px',
          textAlign: 'center',
          boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          maxWidth: '500px',
          width: '100%'
        }}>
          <div style={{
            width: '120px',
            height: '120px',
            margin: '0 auto 30px',
            background: 'linear-gradient(45deg, #ff6b6b, #ee5a6f)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '60px',
            color: 'white',
            animation: 'shake 1s ease-in-out infinite'
          }}>
            ✗
          </div>
          <h1 style={{
            color: '#333',
            marginBottom: '20px',
            fontWeight: '700',
            fontSize: '32px',
            background: 'linear-gradient(45deg, #ff6b6b, #ee5a6f)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>Ödeme Başarısız</h1>
          <p style={{
            color: '#666',
            marginBottom: '30px',
            fontSize: '18px',
            lineHeight: '1.6'
          }}>
            😔 Ödeme işlemi sırasında bir hata oluştu.<br />
            Lütfen tekrar deneyin.
          </p>
          <button
            onClick={handleGoHome}
            style={{
              background: 'linear-gradient(45deg, #ff6b6b, #ee5a6f)',
              color: 'white',
              border: 'none',
              padding: '15px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 10px 25px rgba(255, 107, 107, 0.3)'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 15px 35px rgba(255, 107, 107, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 10px 25px rgba(255, 107, 107, 0.3)';
            }}
          >
            🏠 Ana Sayfaya Dön
          </button>
        </div>
        <style>
          {`
            @keyframes shake {
              0%, 100% { transform: translateX(0); }
              25% { transform: translateX(-5px); }
              75% { transform: translateX(5px); }
            }
          `}
        </style>
      </div>
    );
  }
};

export default PaymentResult;